
import externalConfiguration from '../external-configuration';

export default class PlayerDataSender {
  constructor( player, basePlayer) {
    this.player = player;
    this.basePlayer = basePlayer

    this.onAdImpression = this.onAdImpression.bind(this);

    player.on( 'adImpression', this.onAdImpression);
  }

  onAdImpression( adInfo) {
    if( adInfo && adInfo.mediafile && adInfo.mediafile.file) {
      const query = new URLSearchParams(adInfo.mediafile.file.split('?').slice(1).join('?'));
      const iframeId = this.basePlayer.props.id;
      const advertId = query.get('advertId');
      const prePostRollId = query.get('preRollId') || query.get('postRollId');
      const midRollId = query.get('midRollId');
      const endpoint = prePostRollId ? 'prePostRollView' : 'midRollView';
      const uri = `${externalConfiguration.apiCDNDomain}${externalConfiguration.apiDelayedPath}playerData/${endpoint}`;
      const headers = { 'Content-Type': 'application/json', };
      const data = { iframeId, advertId, prePostRollId, midRollId, };
      const options = { method: 'POST', headers, uri, body: JSON.stringify( data), };

      fetch( uri, options);//.then( response => console.log( response));
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/PlayerDataSender.js